<template>
  <div>
    <div class="table-responsive" v-if="!isLoading">
      <table class="table table-bordered text-center align-middle">
        <thead role="rowgroup" class="text-center">
          <tr role="row">
            <th
              class="position-relative overflow-hidden p-0"
              style="width: 200px"
            >
              <div v-if="pivot_key === 'exercises'">
                <span class="text-pos-right">
                  {{ $lang.competencie }}
                </span>
                <svg height="100%" width="100%">
                  <line
                    x1="0"
                    y1="100%"
                    x2="100%"
                    y2="0"
                    style="stroke: rgb(178 186 193); stroke-width: 2"
                  ></line>
                </svg>
                <span class="text-pos-left">
                  {{ $lang.exercise }}
                </span>
              </div>
              <div v-if="pivot_key === 'competencies'">
                <span class="text-pos-right">
                  {{ $lang.exercise }}
                </span>
                <svg height="100%" width="100%">
                  <line
                    x1="0"
                    y1="100%"
                    x2="100%"
                    y2="0"
                    style="stroke: rgb(178 186 193); stroke-width: 2"
                  ></line>
                </svg>
                <span class="text-pos-left">
                  {{ $lang.competencie }}
                </span>
              </div>
            </th>
            <th
              class="text-center align-middle cursor_pointer position-relative"
              style="width: 200px"
              v-for="(column, index) in columns"
              :key="index"
              role="columnheader"
              scope="col"
              @mouseover="
                showAssessorIndex = pivot_key === 'exercises' ? index : null
              "
              @mouseleave="showAssessorIndex = null"
            >
              <span
                v-text="column.caption"
                class="text-darkslateblue"
                :class="{ 'font-weight-bold': column.bold }"
              />
              <div
                v-if="showAssessorIndex === index && column.assessor"
                class="bg-white rounded border p-1 assessor__box"
              >
                <AvatarInfo
                  :avatarAddress="
                    pathOr(null, ['assessor', 'person', 'img_thumb'], column)
                  "
                  :imageAddress="
                    pathOr(null, ['assessor', 'person', 'img_original'], column)
                  "
                  :title="
                    pathOr('*****', ['assessor', 'person', 'full_name'], column)
                  "
                  :description="
                    `${$lang.assessorCode}: ` +
                    pathOr(
                      '',
                      ['assessor', 'person_center_execute_code'],
                      column
                    )
                  "
                  :genderId="
                    +pathOr(1, ['assessor', 'person', 'gender', 'id'], column)
                  "
                  :personCode="
                    pathOr(null, ['assessor', 'person', 'code'], column)
                  "
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(item, index) in items">
            <td
              class="text-danger align-middle read-only-hover position-relative cursor_pointer"
              @mouseover="
                showAssessorIndex = pivot_key === 'competencies' ? index : null
              "
              @mouseleave="showAssessorIndex = null"
            >
              <div
                v-if="showAssessorIndex === index && item.assessor"
                class="bg-white rounded border p-1 assessor__box"
              >
                <AvatarInfo
                  :avatarAddress="
                    pathOr(null, ['assessor', 'person', 'img_thumb'], item)
                  "
                  :imageAddress="
                    pathOr(null, ['assessor', 'person', 'img_original'], item)
                  "
                  :title="
                    pathOr('*****', ['assessor', 'person', 'full_name'], item)
                  "
                  :description="
                    `${$lang.assessorCode}: ` +
                    pathOr('', ['assessor', 'person_center_execute_code'], item)
                  "
                  :genderId="
                    +pathOr(1, ['assessor', 'person', 'gender', 'id'], item)
                  "
                  :personCode="
                    pathOr(null, ['assessor', 'person', 'code'], item)
                  "
                />
              </div>
              <span
                v-text="item.caption"
                class="text-darkslateblue"
                :class="{ 'font-weight-bold': item.bold }"
              />
            </td>
            <template v-for="(column, i) in columns">
              <template v-if="item.type === 'score'">
                <td
                  class="align-middle read-only-hover"
                  :key="i"
                  v-if="column.type === 'average'"
                >
                  <strong v-text="item.average" />
                </td>
                <td
                  :class="{
                    'bg-success-light text-dark':
                      item.score && column.type === 'overall',
                  }"
                  class="align-middle cursor_pointer"
                  :key="i"
                  v-else-if="column.type === 'overall'"
                  @click="overallClicked(item)"
                >
                  <strong v-text="item.score" />
                </td>
                <td
                  v-else-if="item[pivot_key].find((x) => x.id === column.id)"
                  class="align-middle cursor_pointer"
                  :key="i"
                  @click="cellClicked(item, column)"
                >
                  <span
                    v-if="pathOr(0, ['evidence_log_count'], item)"
                    class="text-danger"
                  >
                    <span
                      class="d-md-inline-block d-none"
                      v-b-tooltip.hover
                      :title="
                        $lang.evidence_log_count.replace(
                          '{0}',
                          pathOr(0, ['evidence_log_count'], item)
                        )
                      "
                    >
                      <mdicon name="alert" />
                    </span>
                    <div class="d-md-none font-weight-bold d-flex flex-column">
                      <mdicon name="alert-decagram" />
                      <small class="font-weight-bold">{{
                        $lang.evidence_log_count.replace(
                          "{0}",
                          pathOr(0, ["evidence_log_count"], item)
                        )
                      }}</small>
                    </div>
                  </span>
                  <span
                    v-if="
                      item[pivot_key].find((x) => x.id === column.id)
                        .is_change_final_description
                    "
                    class="text-success mr-2"
                  >
                    <mdicon name="check-circle" />
                  </span>
                  <strong
                    v-text="
                      item[pivot_key].find((x) => x.id === column.id).score
                    "
                  />
                </td>
                <td :key="i" v-else class="bg-secondary-main" />
              </template>
              <template v-else-if="item.type === 'overall'">
                <td
                  class="align-middle read-only-hover cursor_pointer"
                  :key="i"
                  v-if="item[pivot_key].find((x) => x.id === column.id)"
                  @click="
                    overallClicked(
                      item[pivot_key].find((x) => x.id === column.id)
                    )
                  "
                  :class="{
                    'bg-success-light text-dark': item[pivot_key].find(
                      (x) => x.id === column.id
                    ).score,
                  }"
                >
                  <strong>{{
                    item[pivot_key].find((x) => x.id === column.id).score
                  }}</strong>
                </td>
                <td :key="i" v-else class="bg-secondary-main" />
              </template>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AvatarInfo from "@/components/global/AvatarInfo";
import { pathOr } from "ramda";

export default {
  name: "overview-table",
  components: {
    AvatarInfo,
  },
  props: {
    columns: {
      type: Array,
    },
    items: {
      type: Array,
    },
    pivot_key: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      edit_mode: [],
      isLoading: false,
      showAssessorIndex: null,
    };
  },
  computed: {
    visible() {
      return this.isLoading || this.loading;
    },
  },
  methods: {
    pathOr,
    cellClicked(item, column) {
      if (item[this.pivot_key].find((x) => x.id === column.id).score === null)
        return;

      let x = null;
      if (column.type == "overall")
        x = item[this.pivot_key].find((x) => x.type == column.type);
      else x = item[this.pivot_key].find((x) => x.id == column.id);
      if (x) {
        const score_suggest = pathOr(0, ["score_suggest"], item);
        const evidence_log_count = pathOr(0, ["evidence_log_count"], item);
        x = { ...x, score_suggest, evidence_log_count };
        this.$emit("cellClicked", x);
      }
    },
    overallClicked(item) {
      this.$emit("overallClicked", item);
    },
  },
};
</script>

<style scoped lang="scss">
.read-only-hover:hover {
  background-color: grey !important;
  color: white !important;
}

.table tbody tr td:hover {
  background-color: #fb9692;
  color: white !important;
}

.line {
  position: relative;

  &:after {
    position: absolute;
    content: "";
    width: 2px;
    height: 110px;
    background: lightgrey;
    left: 0;
    top: -61px;
    transform: rotate(45deg);
  }
}

.bg-secondary-main {
  background-color: #969ca0 !important;
}

@media (max-width: 1200px) {
  .line {
    &:after {
      height: 149px;

      left: 12px;
      top: -103px;
      transform: rotate(31deg);
    }
  }
}

.text-pos-left {
  position: absolute;
  top: 5%;
  left: 5%;
}

.text-pos-right {
  position: absolute;
  bottom: 5%;
  right: 5%;
}
.bg-success-light {
  background-color: #96ff788a;
}
.assessor__box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  min-width: 200px;
  z-index: 999;
}
</style>
